export const fontData = [
  'Arial',
  'Oswald',
  'Anton',
  'Archivo Black',
  'Bebas Neue',
  'Caprasimo',
  'Caveat',
  'Josefin Sans',
  'Lobster',
  'Permanent Marker',
  'Playfair Display',
  'Rajdhani',
  'Great Vibes',
  'Roboto',
  'Russo One',
  'Shadows Into Light',
  'Teko',
  'Tilt Prism',
  'Dancing Script',
];
